import InvestStatementPage from './InvestStatementPage';

export default InvestStatementPage;
